import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LoggingService } from 'src/app/services/logging.service';
//import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiUrl = null;
  tokenKey = null;
  constructor(private http: HttpClient, private logging: LoggingService) { }
  getAccessToken() {
    return localStorage.getItem('access_token');
  }
  private getHeaders(file = false) {
    let headers = new HttpHeaders();
    if (!file) {
      headers = headers.set('Content-Type', 'application/json');
    }

    headers = headers.set('Authorization', `Bearer ${this.getAccessToken()}`);
    return headers;
  }
  getApi(url: string): Observable<any> {
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  postApi(url: string, postValue: any, file = false): Observable<any> {
    return this.http.post(url, postValue, { headers: this.getHeaders(file) }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  putApi(url: string, postValue: any, file = false): Observable<any> {
    return this.http.put(url, postValue, { headers: this.getHeaders(file) }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  deleteApi(url: string): Observable<any> {
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  catchError(err: Error) {
    throw err
  }
  getUserProfile(userId, appId = null) {
    var data = {
      "userId": userId,
      "appId": appId
    }
    return this.postApi(this.apiUrl + "Users/GetUserProfile", data);
  }
  initiatePasswordReset(data) {
    return this.postApi(this.apiUrl + `v0.2/Account/InitiatePasswordReset`, data);
  }
  uploadUserProfileImage(data) {
    return this.postApi(this.apiUrl + `Users/UploadUserProfileImage`, data, true);
  }
  uploadUserProfileDetails(data) {
    return this.postApi(this.apiUrl + `Users/UpdateUserProfileDetails`, data, true);
  }
  mhsProfileUpdate(data) {
    return this.postApi(this.apiUrl + 'users/UpdateUserProfileInfo', data, true);
  }
  updateUserProfileSettings(data) {
    return this.postApi(this.apiUrl + `Users/UpdateUserPrivateSetting`, data, true);
  }
  updateUserProfileConsentData(data) {
    return this.postApi(this.apiUrl + `Users/UpdateUserConsentDetails`, data, true);
  }
  delUserRquest(userId) {
    return this.getApi(this.apiUrl + `Users/DeleteUserRequest/${userId}`);
  }
  delUserRecord(otp) {
    return this.deleteApi(this.apiUrl + `Users/DeleteUser/${otp}`);
  }
  changePassword(data) {
    return this.postApi(this.apiUrl + `Account/ChangePassword`, data, true);
  }
  changeMHSPassword(data) {
    return this.putApi(this.apiUrl + `Accounts/ChangePassword`, data, true);
  }
  profileEditAuth(data) {
    return this.postApi(this.apiUrl + `Account/UserProfileEditAuth`, data, true);
  }
  mhsprofileEditAuth(data) {
    return this.postApi(this.apiUrl + `Accounts/UserProfileEditAuth`, data, true);
  }
  updateConsent(data) {
    return this.postApi(this.apiUrl + `Users/UpdateUserConsent`, data, true);
  }
}
